import { Nullable } from 'global';

export enum BpfChangeType {
  CLOSED_REASON_ACTIVATED = 'CLOSED_REASON_ACTIVATED',
  CLOSED_REASON_CREATED = 'CLOSED_REASON_CREATED',
  CLOSED_REASON_DEACTIVATED = 'CLOSED_REASON_DEACTIVATED',
  CLOSED_REASON_REMOVED = 'CLOSED_REASON_REMOVED',
  CLOSED_REASON_RENAMED = 'CLOSED_REASON_RENAMED',
  RULE_CHANGED = 'RULE_CHANGED',
  STAGE_COMPLETED = 'STAGE_COMPLETED',
  STAGE_NOTIFICATION_CHANGED = 'STAGE_NOTIFICATION_CHANGED',
  STAGE_RENAMED = 'STAGE_RENAMED',
  TEMPLATE_ACTIVATED = 'TEMPLATE_ACTIVATED',
  TEMPLATE_CREATED = 'TEMPLATE_CREATED',
  TEMPLATE_DEACTIVATED = 'TEMPLATE_DEACTIVATED',
  TEMPLATE_DUPLICATED = 'TEMPLATE_DUPLICATED',
  TEMPLATE_RENAMED = 'TEMPLATE_RENAMED',
}

export interface BpfChangelogModifiedBy {
  id: string;
  email: string;
  fullName: string;
  lastName: Nullable<string>;
  firstName: Nullable<string>;
}

export interface BpfChangelogViewModel {
  id: string;
  accountId: string;
  changeType: BpfChangeType;
  changes: Record<string, unknown>;
  createdDateTime: string;
  parentId: string;
  modifiedBy: Nullable<BpfChangelogModifiedBy>;
}
